import { render, staticRenderFns } from "./iframePage.vue?vue&type=template&id=5d950e65&scoped=true&"
import script from "./iframePage.vue?vue&type=script&lang=js&"
export * from "./iframePage.vue?vue&type=script&lang=js&"
import style0 from "./iframePage.vue?vue&type=style&index=0&id=5d950e65&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d950e65",
  null
  
)

export default component.exports